import type { AxiosError } from 'axios';
import type { PostAuthenticateInviteResponse } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';
import { MS_PER_SECOND } from '@/utils/time';

export interface PostAuthenticateInviteRequest {
  magicToken: string;
  accessToken: string;
}

export function usePostAuthenticateInvite() {
  return useApiMutation<PostAuthenticateInviteResponse, AxiosError, PostAuthenticateInviteRequest>({
    mutationFn:
      (api) =>
      async ({ magicToken, accessToken }) => {
        if (!accessToken) throw new Error('An authenticated Cognito session is required');
        const { data } = await api.auth.creatorsAuthControllerPostAuthenticateInvite(
          magicToken,
          `Bearer ${accessToken}`,
          { timeout: 10 * MS_PER_SECOND }
        );
        if (!data.success) throw new Error('Creator linking did not complete');
        return data;
      },
  });
}
